import { useEffect } from 'react'

function DeepLink() {
  const urlParams = new URLSearchParams(window.location.search)
  const announcementId = urlParams.get('announcement')

  let appUrl = 'mellro://'
  let webUrl = 'https://welcome.mellro.com'

  if (announcementId) {
    appUrl += `announcement?id=${announcementId}`
    webUrl += '/todo'
  }

  useEffect(() => {
    const now = new Date().valueOf()
    setTimeout(function () {
      if (new Date().valueOf() - now > 100) return
      window.location = webUrl
    }, 25)

    window.location = appUrl
  })

  return null
}

export default DeepLink
